export default __webpack_public_path__ + "static/media/Hamburger Menu.c4da44b0.svg";